import { Fonts, ThemeStyleRadius } from './enums';
import { createTheme } from '@mui/material/styles';

const cardRadius = ThemeStyleRadius.STANDARD;

export const textLight = {
  primary: '#111827',
  disabled: '#959ca9',
  secondary: '#6b7280',
};

export const textDark = {
  primary: 'rgb(255,255,255)',
  secondary: 'rgb(229, 231, 235)',
  disabled: 'rgb(156, 163, 175)',
};

export const defaultTheme = createTheme({
  spacing: 4,
  direction: 'ltr',
  palette: {
    mode: 'light',
    background: {
      paper: '#FFFFFF',
      default: '#F4F7FE',
    },
    primary: {
      main: '#725EBF',
      contrastText: '#fff',
    },
    secondary: {
      main: '#5F538C',
      contrastText: '#fff',
    },
    success: {
      main: '#11C15B',
      light: '#D9F5E5',
    },
    warning: {
      main: '#FF5252',
      light: '#FFECDC',
    },
    text: textLight,
  },
  typography: {
    fontFamily: ['Poppins', 'sans-serif'].join(','),
    fontSize: 14,
    h1: {
      fontSize: 22,
      fontWeight: Fonts.SEMI_BOLD,
    },
    h2: {
      fontSize: 20,
      fontWeight: Fonts.MEDIUM,
    },
    h3: {
      fontSize: 18,
      fontWeight: Fonts.MEDIUM,
    },
    h4: {
      fontSize: 16,
      fontWeight: Fonts.MEDIUM,
    },
    h5: {
      fontSize: 14,
      fontWeight: Fonts.MEDIUM,
    },
    h6: {
      fontSize: 12,
      fontWeight: Fonts.MEDIUM,
    },
    subtitle1: {
      fontSize: 14,
    },
    subtitle2: {
      fontSize: 16,
    },
    body1: {
      fontSize: 14,
    },
    body2: {
      fontSize: 12,
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          background: '#F4F7FE',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          input: {
            borderColor: '#959CA9',
          },
          '& .Mui-disabled': {
            webkitTextFillColor: 'rgba(43, 49, 55, 0.8) !important',
            borderRadius: 7,
            background: '#E0E0E0',
          },
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          borderRadius: cardRadius,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: cardRadius,
          boxShadow: '0px 10px 10px 4px rgba(0, 0, 0, 0.04)',
          '& .MuiCardContent-root:last-of-type': {
            paddingBottom: 16,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: cardRadius / 2,
          textTransform: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: cardRadius / 2,
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: cardRadius / 2,
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 9,
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontWeight: Fonts.REGULAR,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        action: {
          paddingTop: 0,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          marginTop: 5,
          boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.08)',
          borderRadius: '8px 0px 8px 8px',
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          '& .MuiPaper-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: '10px 20px',
          fontSize: 14,
          color: '#ffffff',
          backgroundColor: '#111827',
          borderRadius: '0px 8px 8px 8px',
        },
        arrow: {
          color: '#111827',
        },
      },
    },
  },
});
